import { render, staticRenderFns } from "./CustomerUserAgreement.vue?vue&type=template&id=b1ec9864"
import script from "./CustomerUserAgreement.vue?vue&type=script&lang=js"
export * from "./CustomerUserAgreement.vue?vue&type=script&lang=js"
import style0 from "./CustomerUserAgreement.vue?vue&type=style&index=0&id=b1ec9864&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports